var _style, _text, _style2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleComingsoonFloatinLefttorightText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 630 120",
    preserveAspectRatio: "xMidYMid",
    style: {
      display: "block",
      shapeRendering: "auto",
      background: "transparent"
    },
    width: 630,
    height: 120,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n  .ld-text text {\r\n    text-anchor: middle;\r\n    dominant-baseline: middle;\r\n    font-size: 100px;\r\n    opacity: 0;\r\n    user-select: none;\r\n    pointer-events: none;\r\n  }\r\n")), /*#__PURE__*/React.createElement("g", {
    style: {
      transformOrigin: "315px 60px",
      transform: "scale(1)"
    },
    className: "ld-text"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,60)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.2500) translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 0,
      transformOrigin: "-219.32px -4.77px",
      transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -15, 0, 0, 1)",
      animation: "1s linear 0s 1 normal forwards running animate-nnw5z2yfbdd",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.48 51.10L18.08 60.62Q11.76 57.50 7.76 49.58L7.76 49.58Q5.76 45.58 4.60 40.58Q3.44 35.58 3.44 29.58L3.44 29.58Q3.44 15.58 9.72 2.54Q16-10.50 28.24-20.50L28.24-20.50L38.32-10.98Q34.96-8.10 31.08-4.10Q27.20-0.10 24 4.86L24 4.86Q20.80 9.90 18.68 15.94Q16.56 21.98 16.56 28.94L16.56 28.94Q16.56 32.62 17.68 36.14Q18.80 39.66 20.60 42.66Q22.40 45.66 24.48 47.86Q26.56 50.06 28.48 51.10L28.48 51.10",
    style: {
      fill: "rgb(148, 132, 223)"
    },
    transform: "translate(-240.200,-24.829)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 0,
      transformOrigin: "-195.24px -4.33px",
      transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -15, 0, 0, 1)",
      animation: "1s linear 0.044s 1 normal forwards running animate-nnw5z2yfbdd",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.52 49.82L37.52 49.82Q32.48 49.82 29.28 45.10Q26.08 40.38 26.08 32.14L26.08 32.14Q26.08 24.62 28.16 17.30Q30.24 9.98 34 4.14L34 4.14Q37.76-1.70 42.92-5.26Q48.08-8.82 54.32-8.82L54.32-8.82Q58.24-8.82 61.04-5.78Q63.84-2.74 63.84 2.38L63.84 2.38L63.84 3.34Q63.84 3.66 63.84 3.90Q63.84 4.14 63.76 4.46L63.76 4.46L53.28 7.26Q52.32 5.26 51.04 5.26L51.04 5.26Q49.12 5.26 47 8.38Q44.88 11.50 42.96 15.82L42.96 15.82Q41.68 18.70 40.68 21.74Q39.68 24.78 39.12 27.42Q38.56 30.06 38.56 31.74L38.56 31.74Q38.56 34.22 39.28 35.34L39.28 35.34Q39.84 36.38 41.04 36.38L41.04 36.38Q42.24 36.38 43.68 35.22Q45.12 34.06 46.36 32.30Q47.60 30.54 48 28.78L48 28.78L57.12 32.46Q53.20 41.42 47.80 45.62Q42.40 49.82 37.52 49.82",
    style: {
      fill: "rgb(148, 132, 223)"
    },
    transform: "translate(-240.200,-24.829)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 0,
      transformOrigin: "-160.48px -4.93px",
      transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -15, 0, 0, 1)",
      animation: "1s linear 0.088s 1 normal forwards running animate-nnw5z2yfbdd",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.56 49.98L70.56 49.98Q65.28 49.98 61.92 45.90Q58.56 41.82 58.56 33.58L58.56 33.58Q58.56 29.02 59.68 23.98Q60.80 18.94 62.80 14.06Q64.80 9.18 67.44 5.02L67.44 5.02Q71.68-1.70 77.20-5.94Q82.72-10.18 88.80-10.18L88.80-10.18Q93.60-10.18 96.20-7.74Q98.80-5.30 99.84-1.50Q100.88 2.30 100.88 6.38L100.88 6.38Q100.88 15.90 97.96 24.10Q95.04 32.30 90.40 37.98L90.40 37.98Q85.76 43.82 80.52 46.90Q75.28 49.98 70.56 49.98 zM74.88 36.78L74.88 36.78Q78.48 36.78 81.24 34.38Q84 31.98 85.92 28.26Q87.84 24.54 88.80 20.46Q89.76 16.38 89.76 13.10L89.76 13.10Q89.76 11.82 89.52 10.34Q89.28 8.86 88.48 7.74Q87.68 6.62 86 6.62L86 6.62Q82.32 6.62 79.36 9.30Q76.40 11.98 74.40 16.06L74.40 16.06Q72.40 20.22 71.44 24.22Q70.48 28.22 70.48 31.50L70.48 31.50Q70.48 33.18 71.68 34.98Q72.88 36.78 74.88 36.78",
    style: {
      fill: "rgb(148, 132, 223)"
    },
    transform: "translate(-240.200,-24.829)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 0,
      transformOrigin: "-118.36px -5.61px",
      transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -15, 0, 0, 1)",
      animation: "1s linear 0.132s 1 normal forwards running animate-nnw5z2yfbdd",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.32 48.30L93.12 49.18Q96.64 38.46 99.84 28.30L99.84 28.30Q101.20 24.14 102.64 19.42Q104.08 14.70 105.52 9.94Q106.96 5.18 108.24 0.78Q109.52-3.62 110.40-7.06L110.40-7.06Q114.80-7.06 118.72-7.54L118.72-7.54Q120.72-7.78 122.84-8.02Q124.96-8.26 127.20-8.42L127.20-8.42L126.72-4.50Q126.56-3.38 126.40-2.22Q126.24-1.06 126.08 0.14L126.08 0.14Q125.92 1.34 125.68 2.58Q125.44 3.82 125.28 5.10L125.28 5.10Q124.96 7.58 124.32 12.02Q123.68 16.46 122.80 21.66L122.80 21.66L123.84 21.66Q126.16 15.58 127.68 11.54Q129.20 7.50 130.16 4.94L130.16 4.94Q131.52 1.18 133.12-2.66Q134.72-6.50 135.76-8.58L135.76-8.58Q137.68-8.74 140.36-9.10Q143.04-9.46 145.80-9.94Q148.56-10.42 150.56-10.74L150.56-10.74Q149.44-4.02 148.52 2.82Q147.60 9.66 146.92 15.86Q146.24 22.06 145.76 27.02L145.76 27.02Q145.28 31.98 144.88 36.82Q144.48 41.66 144.08 46.38L144.08 46.38L130.16 48.86Q130.16 48.70 130.40 45.26Q130.64 41.82 131.20 36.70L131.20 36.70Q131.76 31.58 132.32 26.98Q132.88 22.38 133.44 19.42L133.44 19.42L132.72 19.42Q130.72 25.50 127.88 32.70Q125.04 39.90 122.32 48.62L122.32 48.62Q119.52 48.70 117.52 48.82Q115.52 48.94 112.88 49.10L112.88 49.10L115.44 19.42L114.24 19.42Q114.16 20.30 113.52 22.82Q112.88 25.34 112 28.58Q111.12 31.82 110.16 35.02L110.16 35.02Q106.56 47.58 106.32 48.30L106.32 48.30",
    style: {
      fill: "rgb(148, 132, 223)"
    },
    transform: "translate(-240.200,-24.829)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 0,
      transformOrigin: "-83.56px -4.21px",
      transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -15, 0, 0, 1)",
      animation: "1s linear 0.176s 1 normal forwards running animate-nnw5z2yfbdd",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.44 49.58L145.44 49.58Q146.56 44.94 147.68 39.06Q148.80 33.18 149.92 26.86Q151.04 20.54 152 14.70L152 14.70Q152.88 9.58 153.72 4.30Q154.56-0.98 155.36-6.34L155.36-6.34L167.84-8.34L164.24 12.70Q163.04 20.14 162.12 26.06Q161.20 31.98 160.36 37.26Q159.52 42.54 158.64 48.06L158.64 48.06Q157.12 48.06 154.96 48.26Q152.80 48.46 150.64 48.74Q148.48 49.02 147 49.26Q145.52 49.50 145.44 49.58",
    style: {
      fill: "rgb(148, 132, 223)"
    },
    transform: "translate(-240.200,-24.829)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 0,
      transformOrigin: "-56.52px -4.97px",
      transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -15, 0, 0, 1)",
      animation: "1s linear 0.22s 1 normal forwards running animate-nnw5z2yfbdd",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.28 47.34L161.60 50.06Q164 38.54 166.16 27.74L166.16 27.74Q167.92 17.58 169.60 8.22Q171.28-1.14 172-8.98L172-8.98Q172.56-8.90 173-8.90Q173.44-8.90 173.76-8.90L173.76-8.90L175.44-8.90Q177.52-8.90 180.08-9.02Q182.64-9.14 184.80-9.22L184.80-9.22Q185.36-6.42 185.88-3.70Q186.40-0.98 186.80 1.58L186.80 1.58Q187.20 3.82 187.68 6.18Q188.16 8.54 188.64 10.94L188.64 10.94Q189.04 13.34 189.48 15.38Q189.92 17.42 190.24 19.10L190.24 19.10Q191.20 14.38 192.04 9.82Q192.88 5.26 193.68 1.58L193.68 1.58L196-9.14L205.76-10.34Q204.40-4.26 203.20 1.58Q202 7.42 200.96 12.86L200.96 12.86Q198.96 22.62 197.44 31.26Q195.92 39.90 195.12 46.30L195.12 46.30Q196 46.30 194.84 46.50Q193.68 46.70 191.44 47.06Q189.20 47.42 186.64 47.98Q184.08 48.54 182.08 49.34L182.08 49.34Q181.84 46.14 181.60 43.10Q181.36 40.06 181.04 37.18L181.04 37.18Q180.56 32.06 179.92 27.02Q179.28 21.98 178.64 19.02L178.64 19.02Q178.08 22.54 177.28 27.06Q176.48 31.58 175.52 36.14L175.52 36.14L173.28 47.34",
    style: {
      fill: "rgb(148, 132, 223)"
    },
    transform: "translate(-240.200,-24.829)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 0,
      transformOrigin: "-18.44px -4.13px",
      transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -15, 0, 0, 1)",
      animation: "1s linear 0.264s 1 normal forwards running animate-nnw5z2yfbdd",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.20 51.58L215.20 51.58Q212.24 51.58 209.56 50.30Q206.88 49.02 204.96 46.38L204.96 46.38Q202.96 43.82 201.84 39.90Q200.72 35.98 200.72 30.70L200.72 30.70Q200.72 20.38 203.68 12.70Q206.64 5.02 211.20-0.10L211.20-0.10Q215.68-5.22 220.84-7.70Q226-10.18 230.48-10.18L230.48-10.18Q234.80-10.18 237.52-8.30Q240.24-6.42 241.52-3.30Q242.80-0.18 242.80 3.66L242.80 3.66L231.84 5.74Q231.12 2.54 229.92 1.18Q228.72-0.18 227.20-0.18L227.20-0.18Q225.44-0.18 223.56 1.74Q221.68 3.66 219.88 6.90Q218.08 10.14 216.64 14.14Q215.20 18.14 214.28 22.38Q213.36 26.62 213.20 30.38L213.20 30.38Q213.20 35.34 214.68 37.46Q216.16 39.58 218.48 39.58L218.48 39.58Q220.72 39.58 222.92 38.14Q225.12 36.70 226.60 34.26Q228.08 31.82 228.16 28.78L228.16 28.78L219.60 30.06L221.12 22.14L228.48 21.18Q231.52 20.78 234.92 20.22Q238.32 19.66 240.88 19.18L240.88 19.18Q240.32 27.34 237.72 33.46Q235.12 39.58 231.28 43.58Q227.44 47.58 223.24 49.58Q219.04 51.58 215.20 51.58",
    style: {
      fill: "rgb(148, 132, 223)"
    },
    transform: "translate(-240.200,-24.829)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 0,
      transformOrigin: "33.92px -4.29px",
      transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -15, 0, 0, 1)",
      animation: "1s linear 0.308s 1 normal forwards running animate-nnw5z2yfbdd",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.56 49.82L266.56 49.82Q263.36 49.82 260.16 48.10Q256.96 46.38 254 42.62L254 42.62L259.92 31.02Q260.80 32.54 262.52 33.90Q264.24 35.26 266.16 36.06Q268.08 36.86 269.44 36.86L269.44 36.86Q271.52 36.86 273.40 35.58Q275.28 34.30 275.28 32.14L275.28 32.14Q275.28 29.34 272.72 27.02Q270.16 24.70 266.96 22.46L266.96 22.46Q263.84 20.22 261.24 17.38Q258.64 14.54 258.64 10.86L258.64 10.86Q258.64 6.70 261.04 3.14Q263.44-0.42 267.28-3.10Q271.12-5.78 275.48-7.26Q279.84-8.74 283.76-8.74L283.76-8.74Q286.56-8.74 288.96-7.82Q291.36-6.90 292.80-4.82Q294.24-2.74 294.24 0.78L294.24 0.78Q294.24 1.34 294.20 1.90Q294.16 2.46 294.08 3.02L294.08 3.02Q294 3.58 293.88 4.18Q293.76 4.78 293.68 5.42L293.68 5.42L282.08 8.78Q282.24 8.14 282.36 7.50Q282.48 6.86 282.48 6.22L282.48 6.22Q282.48 3.82 281.64 2.74Q280.80 1.66 279.44 1.66L279.44 1.66Q278.72 1.66 277.36 2.42Q276 3.18 274.92 4.50Q273.84 5.82 273.84 7.42L273.84 7.42Q273.84 10.06 276.04 11.78Q278.24 13.50 281.12 15.26L281.12 15.26Q282.48 16.06 284.16 17.78Q285.84 19.50 287.08 22.42Q288.32 25.34 288.32 29.90L288.32 29.90Q288.32 35.82 285.40 40.30Q282.48 44.78 277.52 47.30Q272.56 49.82 266.56 49.82",
    style: {
      fill: "rgb(148, 132, 223)"
    },
    transform: "translate(-240.200,-24.829)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 0,
      transformOrigin: "70.72px -4.93px",
      transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -15, 0, 0, 1)",
      animation: "1s linear 0.352s 1 normal forwards running animate-nnw5z2yfbdd",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.76 49.98L301.76 49.98Q296.48 49.98 293.12 45.90Q289.76 41.82 289.76 33.58L289.76 33.58Q289.76 29.02 290.88 23.98Q292 18.94 294 14.06Q296 9.18 298.64 5.02L298.64 5.02Q302.88-1.70 308.40-5.94Q313.92-10.18 320-10.18L320-10.18Q324.80-10.18 327.40-7.74Q330-5.30 331.04-1.50Q332.08 2.30 332.08 6.38L332.08 6.38Q332.08 15.90 329.16 24.10Q326.24 32.30 321.60 37.98L321.60 37.98Q316.96 43.82 311.72 46.90Q306.48 49.98 301.76 49.98 zM306.08 36.78L306.08 36.78Q309.68 36.78 312.44 34.38Q315.20 31.98 317.12 28.26Q319.04 24.54 320 20.46Q320.96 16.38 320.96 13.10L320.96 13.10Q320.96 11.82 320.72 10.34Q320.48 8.86 319.68 7.74Q318.88 6.62 317.20 6.62L317.20 6.62Q313.52 6.62 310.56 9.30Q307.60 11.98 305.60 16.06L305.60 16.06Q303.60 20.22 302.64 24.22Q301.68 28.22 301.68 31.50L301.68 31.50Q301.68 33.18 302.88 34.98Q304.08 36.78 306.08 36.78",
    style: {
      fill: "rgb(148, 132, 223)"
    },
    transform: "translate(-240.200,-24.829)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 0,
      transformOrigin: "110.16px -4.93px",
      transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -15, 0, 0, 1)",
      animation: "1s linear 0.396s 1 normal forwards running animate-nnw5z2yfbdd",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.20 49.98L341.20 49.98Q335.92 49.98 332.56 45.90Q329.20 41.82 329.20 33.58L329.20 33.58Q329.20 29.02 330.32 23.98Q331.44 18.94 333.44 14.06Q335.44 9.18 338.08 5.02L338.08 5.02Q342.32-1.70 347.84-5.94Q353.36-10.18 359.44-10.18L359.44-10.18Q364.24-10.18 366.84-7.74Q369.44-5.30 370.48-1.50Q371.52 2.30 371.52 6.38L371.52 6.38Q371.52 15.90 368.60 24.10Q365.68 32.30 361.04 37.98L361.04 37.98Q356.40 43.82 351.16 46.90Q345.92 49.98 341.20 49.98 zM345.52 36.78L345.52 36.78Q349.12 36.78 351.88 34.38Q354.64 31.98 356.56 28.26Q358.48 24.54 359.44 20.46Q360.40 16.38 360.40 13.10L360.40 13.10Q360.40 11.82 360.16 10.34Q359.92 8.86 359.12 7.74Q358.32 6.62 356.64 6.62L356.64 6.62Q352.96 6.62 350 9.30Q347.04 11.98 345.04 16.06L345.04 16.06Q343.04 20.22 342.08 24.22Q341.12 28.22 341.12 31.50L341.12 31.50Q341.12 33.18 342.32 34.98Q343.52 36.78 345.52 36.78",
    style: {
      fill: "rgb(148, 132, 223)"
    },
    transform: "translate(-240.200,-24.829)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 0,
      transformOrigin: "148.44px -4.97px",
      transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -15, 0, 0, 1)",
      animation: "1s linear 0.44s 1 normal forwards running animate-nnw5z2yfbdd",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.24 47.34L366.56 50.06Q368.96 38.54 371.12 27.74L371.12 27.74Q372.88 17.58 374.56 8.22Q376.24-1.14 376.96-8.98L376.96-8.98Q377.52-8.90 377.96-8.90Q378.40-8.90 378.72-8.90L378.72-8.90L380.40-8.90Q382.48-8.90 385.04-9.02Q387.60-9.14 389.76-9.22L389.76-9.22Q390.32-6.42 390.84-3.70Q391.36-0.98 391.76 1.58L391.76 1.58Q392.16 3.82 392.64 6.18Q393.12 8.54 393.60 10.94L393.60 10.94Q394 13.34 394.44 15.38Q394.88 17.42 395.20 19.10L395.20 19.10Q396.16 14.38 397 9.82Q397.84 5.26 398.64 1.58L398.64 1.58L400.96-9.14L410.72-10.34Q409.36-4.26 408.16 1.58Q406.96 7.42 405.92 12.86L405.92 12.86Q403.92 22.62 402.40 31.26Q400.88 39.90 400.08 46.30L400.08 46.30Q400.96 46.30 399.80 46.50Q398.64 46.70 396.40 47.06Q394.16 47.42 391.60 47.98Q389.04 48.54 387.04 49.34L387.04 49.34Q386.80 46.14 386.56 43.10Q386.32 40.06 386 37.18L386 37.18Q385.52 32.06 384.88 27.02Q384.24 21.98 383.60 19.02L383.60 19.02Q383.04 22.54 382.24 27.06Q381.44 31.58 380.48 36.14L380.48 36.14L378.24 47.34",
    style: {
      fill: "rgb(148, 132, 223)"
    },
    transform: "translate(-240.200,-24.829)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 0,
      transformOrigin: "170.12px 18.95px",
      transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -15, 0, 0, 1)",
      animation: "1s linear 0.484s 1 normal forwards running animate-nnw5z2yfbdd",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.72 51.50L408.72 51.50Q406.32 51.50 404.76 50.34Q403.20 49.18 402.44 47.46Q401.68 45.74 401.68 43.98L401.68 43.98Q401.68 40.78 403.80 38.42Q405.92 36.06 409.68 36.06L409.68 36.06Q414.32 36.06 416.64 38.26Q418.96 40.46 418.96 43.26L418.96 43.26Q418.96 46.46 416.32 48.98Q413.68 51.50 408.72 51.50",
    style: {
      fill: "rgb(148, 132, 223)"
    },
    transform: "translate(-240.200,-24.829)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 0,
      transformOrigin: "186.84px 18.95px",
      transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -15, 0, 0, 1)",
      animation: "1s linear 0.528s 1 normal forwards running animate-nnw5z2yfbdd",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.44 51.50L425.44 51.50Q423.04 51.50 421.48 50.34Q419.92 49.18 419.16 47.46Q418.40 45.74 418.40 43.98L418.40 43.98Q418.40 40.78 420.52 38.42Q422.64 36.06 426.40 36.06L426.40 36.06Q431.04 36.06 433.36 38.26Q435.68 40.46 435.68 43.26L435.68 43.26Q435.68 46.46 433.04 48.98Q430.40 51.50 425.44 51.50",
    style: {
      fill: "rgb(148, 132, 223)"
    },
    transform: "translate(-240.200,-24.829)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 0,
      transformOrigin: "203.56px 18.95px",
      transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -15, 0, 0, 1)",
      animation: "1s linear 0.572s 1 normal forwards running animate-nnw5z2yfbdd",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.16 51.50L442.16 51.50Q439.76 51.50 438.20 50.34Q436.64 49.18 435.88 47.46Q435.12 45.74 435.12 43.98L435.12 43.98Q435.12 40.78 437.24 38.42Q439.36 36.06 443.12 36.06L443.12 36.06Q447.76 36.06 450.08 38.26Q452.40 40.46 452.40 43.26L452.40 43.26Q452.40 46.46 449.76 48.98Q447.12 51.50 442.16 51.50",
    style: {
      fill: "rgb(148, 132, 223)"
    },
    transform: "translate(-240.200,-24.829)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 0,
      transformOrigin: "225.68px -4.77px",
      transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -15, 0, 0, 1)",
      animation: "1s linear 0.616s 1 normal forwards running animate-nnw5z2yfbdd",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.20 60.62L455.20 60.62L447.92 49.50Q453.20 47.18 457.16 42.98Q461.12 38.78 463.72 33.42Q466.32 28.06 467.64 22.34Q468.96 16.62 468.96 11.26L468.96 11.26Q468.96 3.90 466.72-2.02Q464.48-7.94 460.16-11.14L460.16-11.14L472.72-20.50Q478.32-14.18 481.08-6.42Q483.84 1.34 483.84 9.82L483.84 9.82Q483.84 17.34 482.08 24.22Q480.32 31.10 477.32 37.02Q474.32 42.94 470.60 47.70Q466.88 52.46 462.88 55.74Q458.88 59.02 455.20 60.62",
    style: {
      fill: "rgb(148, 132, 223)"
    },
    transform: "translate(-240.200,-24.829)"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    dy: "0.35em",
    fill: "#9484df",
    fontFamily: "Bangers",
    fontSize: 100
  }, "(Coming Soon...)")))), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@keyframes animate-nnw5z2yfbdd { 0.00% {transform: translate(-15.00px,0.00px) rotate(0.00deg) scale(1.00, 1.00) skew(0deg, 0.00deg) ;opacity: 0.00;}2.00% {animation-timing-function: cubic-bezier(0.65,0.72,0.32,0.38);transform: translate(-9.36px,0.00px) rotate(0.00deg) ;opacity: 0.10;}6.00% {transform: translate(-7.58px,0.00px) rotate(0.00deg) ;opacity: 0.30;}8.00% {animation-timing-function: cubic-bezier(0.66,0.69,0.33,0.35);transform: translate(-7.02px,0.00px) rotate(0.00deg) ;opacity: 0.40;}14.00% {transform: translate(-5.82px,0.00px) rotate(0.00deg) ;opacity: 0.70;}16.00% {animation-timing-function: cubic-bezier(0.66,0.68,0.33,0.34);transform: translate(-5.51px,0.00px) rotate(0.00deg) ;opacity: 0.80;}20.00% {animation-timing-function: cubic-bezier(0.22,0.43,0.59,0.75);transform: translate(-4.97px,0.00px) rotate(0.00deg) ;opacity: 1.00;}100.00% {animation-timing-function: cubic-bezier(0.22,0.43,0.59,0.75);transform: translate(0.00px,0.00px) rotate(0.00deg) ;opacity: 1.00;} }")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleComingsoonFloatinLefttorightText);
export default __webpack_public_path__ + "static/media/purple-comingsoon-floatin-lefttoright-text.838e435845f6dc2b3c94e0fd45cfd74c.svg";
export { ForwardRef as ReactComponent };